<template>
    <LoaderSplash :loaded="loaded">
        <b-container v-if="loaded">
            <b-row class="mb-5">
                <b-col xs="12" md="6">
                    <img class="w-100" v-bind:src="event.image">
                </b-col>

                <b-col xs="12" md="6">
                    <div class="divider divider--gold mt-3 mt-md-0 mb-3"></div>

                    <h1 class="text-uppercase">
                        {{ event.name }}
                    </h1>

                    <h2 class="font-italic font-serif font-thin mt-3">
                        {{ address_first_line }}
                    </h2>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <dropdown-container
                        :open="containers.open.invites"
                        :heading="'INVITES'"
                        v-on:open-container="closeContainers(); containers.open.invites = true;"
                        v-on:close-container="closeContainers();">
                        <div class="invite-grid">
                            <div class="invite-grid__row invite-grid__row--border-bottom">
                                <div class="invite-grid-item invite-grid-item--border-bottom invite-grid-item--border-right">
                                    <div class="invite-grid-item__icon">
                                        <span class="inline-fa">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm0-160c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm80.1 212c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9C7.2 341.3 0 363.4 0 387.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM352 432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zm271.7-114.9C606.4 291.5 577 278 546.8 278c-27.8 0-34.8 10-66.8 10s-39-10-66.8-10c-13.2 0-26.1 3-38.1 8.1 15.2 15.4 18.5 23.6 20.2 26.6 5.7-1.6 11.6-2.6 17.9-2.6 21.8 0 30 10 66.8 10s45-10 66.8-10c21 0 39.8 9.3 50.4 25 7.1 10.5 10.9 22.9 10.9 35.7V408c0 4.4-3.6 8-8 8H416c0 17.7.3 22.5-1.6 32H600c22.1 0 40-17.9 40-40v-37.3c0-19.9-6-38.3-16.3-53.6z"/></svg>
                                        </span>
                                    </div>

                                    <div class="invite-grid-item__text">
                                        {{ invites.length }} invited
                                    </div>
                                </div>

                                <div class="invite-grid-item invite-grid-item--border-bottom invite-grid-item--border-right">
                                    <div class="invite-grid-item__icon">
                                        <span class="inline-fa">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 352c0 17.6-14.4 32-32 32H293.3l-8.5 6.4L192 460v-76H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v288zM345.3 134.5c-1.6-1.6-3.6-2.3-5.7-2.3-2 0-4.1.8-5.7 2.3L226.5 241.9 178 193.4c-1.6-1.6-3.6-2.3-5.7-2.3-2 0-4.1.8-5.7 2.3l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l65.5 65.5c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3L356.7 157c3.1-3.1 3.1-8.2 0-11.3l-11.4-11.2z"/></svg>
                                        </span>
                                    </div>

                                    <div class="invite-grid-item__text">
                                        {{ invites_accepted }} accepted
                                    </div>
                                </div>

                                <div class="invite-grid-item invite-grid-item--border-bottom">
                                    <div class="invite-grid-item__icon">
                                        <span class="inline-fa">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 352c0 17.6-14.4 32-32 32H293.3l-8.5 6.4L192 460v-76H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v288zM329.5 145.8l-11.3-11.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3L256 185.4l-50.9-50.9c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l50.9 50.9-50.9 50.9c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l50.9-50.9 50.9 50.9c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-51-50.9 50.9-50.9c3.2-3.1 3.2-8.2 0-11.3z"/></svg>
                                        </span>
                                    </div>

                                    <div class="invite-grid-item__text">
                                        {{ invites_rejected }} rejected
                                    </div>
                                </div>
                            </div>

                            <div class="invite-grid__row">
                                <div class="invite-grid-item invite-grid-item--border-bottom invite-grid-item--border-right">
                                    <div class="invite-grid-item__icon">
                                        <span class="inline-fa">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M288 288a64 64 0 0 0 0-128c-1 0-1.88.24-2.85.29a47.5 47.5 0 0 1-60.86 60.86c0 1-.29 1.88-.29 2.85a64 64 0 0 0 64 64zm284.52-46.6C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 96a128 128 0 1 1-128 128A128.14 128.14 0 0 1 288 96zm0 320c-107.36 0-205.46-61.31-256-160a294.78 294.78 0 0 1 129.78-129.33C140.91 153.69 128 187.17 128 224a160 160 0 0 0 320 0c0-36.83-12.91-70.31-33.78-97.33A294.78 294.78 0 0 1 544 256c-50.53 98.69-148.64 160-256 160z"/></svg>
                                        </span>
                                    </div>

                                    <div class="invite-grid-item__text">
                                        {{ invites_seen }} seen
                                    </div>
                                </div>

                                <div class="invite-grid-item invite-grid-item--border-bottom invite-grid-item--border-right">
                                    <div class="invite-grid-item__icon">
                                        <span class="inline-fa">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M464 4.3L16 262.7C-7 276-4.7 309.9 19.8 320L160 378v102c0 30.2 37.8 43.3 56.7 20.3l60.7-73.8 126.4 52.2c19.1 7.9 40.7-4.2 43.8-24.7l64-417.1C515.7 10.2 487-9 464 4.3zM192 480v-88.8l54.5 22.5L192 480zm224-30.9l-206.2-85.2 199.5-235.8c4.8-5.6-2.9-13.2-8.5-8.4L145.5 337.3 32 290.5 480 32l-64 417.1z"/></svg>
                                        </span>
                                    </div>

                                    <div class="invite-grid-item__text">
                                        {{ invites_sent }} sent
                                    </div>
                                </div>

                                <div class="invite-grid-item">
                                    <div class="invite-grid-item__icon">
                                        <span class="inline-fa">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M493.255 56.236l-37.49-37.49c-24.993-24.993-65.515-24.994-90.51 0L12.838 371.162.151 485.346c-1.698 15.286 11.22 28.203 26.504 26.504l114.184-12.687 352.417-352.417c24.992-24.994 24.992-65.517-.001-90.51zM164.686 347.313c6.249 6.249 16.379 6.248 22.627 0L368 166.627l30.059 30.059L174 420.745V386h-48v-48H91.255l224.059-224.059L345.373 144 164.686 324.687c-6.249 6.248-6.249 16.378 0 22.626zm-38.539 121.285l-58.995 6.555-30.305-30.305 6.555-58.995L63.255 366H98v48h48v34.745l-19.853 19.853zm344.48-344.48l-49.941 49.941-82.745-82.745 49.941-49.941c12.505-12.505 32.748-12.507 45.255 0l37.49 37.49c12.506 12.506 12.507 32.747 0 45.255z"/></svg>
                                        </span>
                                    </div>

                                    <div class="invite-grid-item__text">
                                        {{ invites_unsent }} unsent
                                    </div>
                                </div>
                            </div>
                        </div>

                        <b-button class="tb-button tb-button--blue mt-3 tb-button--spaced" :to="{ name: 'send-invite', params: { id: id } }">
                            CREATE INVITE
                        </b-button>

                        <div class="invite-buttons mt-3">
                            <h4 v-if="!has_itinerary_items" class="mb-3">
                                Invites cannot be sent until the event has at least one itinerary day
                            </h4>

                            <b-button :disabled="!has_itinerary_items" class="tb-table__button tb-table__button--gold" v-if="true" @click="sendPendingInvites()">
                                Send Unsent
                            </b-button>

                            <b-button :disabled="!has_itinerary_items" class="tb-table__button tb-table__button--gold mr-2" @click="resendUnconfirmedInvites()">
                                Resend Unconfirmed
                            </b-button>

                            <vue-csv-downloader
                                :data="csv_invites"
                                :fields="csv_fields"
                                :download-name="csv_filename">
                                <b-button class="tb-table__button tb-table__button--gold mr-2 w-100">
                                    Download As CSV
                                </b-button>
                            </vue-csv-downloader>
                        </div>

                        <div>
                            <b-input-group class="mt-5 ">
                                <b-form-input v-model="filter" placeholder="Type to search" class="mb-0 tb-form-field tb-form-field--with-append" />

                                <b-input-group-append >
                                    <b-button :disabled="!filter" @click="filter = ''" class="tb-form-field__append">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>

                            <b-table class="mt-3 tb-table"
                                     stacked="md"
                                     :filter="filter"
                                     :items="invites"
                                     :fields="fields">

                                <template slot="actions" slot-scope="row">
                                    <b-button class="btn-info mr-2  tb-table__button tb-table__button--gold" :to="{ name: 'invite', params: { invite_id: row.item.id } }">
                                        View
                                    </b-button>

                                    <b-button class="btn-info mr-2  tb-table__button tb-table__button--gold" :to="{ name: 'edit-invite', params: { invite_id: row.item.id } }">
                                        Edit
                                    </b-button>

                                    <b-button class="btn-danger tb-table__button tb-table__button--blue" @click="askDeleteInvite(row.item)">
                                        Delete
                                    </b-button>
                                </template>
                            </b-table>
                        </div>
                    </dropdown-container>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col>
                    <dropdown-container
                        :open="containers.open.details"
                        :heading="'DETAILS'"
                        v-on:open-container="closeContainers(); containers.open.details = true;"
                        v-on:close-container="closeContainers();">
                        <b-row>
                            <b-col xs="12" md="6">
                                <h1>
                                    {{ event.name }}
                                </h1>

                                <h2>
                                    {{ event.client.name }}
                                </h2>

                                <ul class="address">
                                    <li class="address__line" v-for="address_line in split_address">
                                        {{ address_line }}
                                    </li>
                                </ul>
                            </b-col>

                            <b-col xs="12" md="6">
                                <gmap-map
                                    :center="map.reported_center"
                                    :zoom="12"
                                    ref="map"
                                    :class="map.class">
                                    <gmap-marker v-if="map.marker.position" :position="map.marker.position"></gmap-marker>
                                </gmap-map>
                            </b-col>
                        </b-row>
                    </dropdown-container>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col>
                    <dropdown-container
                        :open="containers.open.itinerary"
                        :heading="'ITINERARY'"
                        v-on:open-container="closeContainers(); containers.open.itinerary = true;"
                        v-on:close-container="closeContainers();">
                        <itinerary-form :days="days" :event="event" :can-manage-days="false"></itinerary-form>
                    </dropdown-container>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col>
                    <dropdown-container
                        :open="containers.open.updates"
                        :heading="'UPDATES'"
                        v-on:open-container="closeContainers(); containers.open.updates = true;"
                        v-on:close-container="closeContainers();">
                        <update-form :updates="updates" :event="event"></update-form>
                    </dropdown-container>
                </b-col>
            </b-row>

            <b-modal
                v-model="show_delete_modal"
                id="delete-modal"
                title="Warning"
                @ok="deleteInvite()"
                header-bg-variant="danger"
                header-text-variant="light"
                ok-title="Delete"
                ok-variant="danger">
                Are you sure you want to permanently delete this invite?
            </b-modal>
        </b-container>
    </LoaderSplash>
</template>

<script>
    import ItineraryForm from '@/components/ItineraryForm.vue';
    import UpdateForm from '@/components/UpdateForm.vue';
    import eventRepository from "@/repository/events";
    import inviteRepository from "@/repository/invites";
    import LocationBlock from "@/components/LocationBlock";
    import TimesBlock from "@/components/TimesBlock";
    import VueCsvDownloader from 'vue-csv-downloader';
    import DropdownContainer from "@/components/DropdownContainer";

    let date_format = "DD-MM-YYYY HH:mm";

    export default {
        components: {
            ItineraryForm,
            UpdateForm,
            LocationBlock,
            TimesBlock,
            VueCsvDownloader,
            DropdownContainer
        },

        props: ['id'],

        data() {
            return {
                loaded: false,
                event: null,
                invites: [],
                updates: [],
                days: [],
                itinerary_items: [],
                csv_fields: [
                    'first_name',
                    'last_name',
                    'phone',
                    'email',
                    'status'
                ],
                fields: [
                    {
                        key: 'first_name',
                        sortable: true
                    },
                    {
                        key: 'last_name',
                        sortable: true
                    },
                    {
                        key: 'phone',
                        sortable: true
                    },
                    {
                        key: 'email',
                        sortable: true
                    },
                    {
                        key: 'status',
                        sortable: true
                    },
                    'actions'
                ],
                show_delete_modal: false, 
                invite_to_delete: null,
                filter: "",
                current_page:0,
                map: {
                    reported_center: {
                        lat: 1.32,
                        lng: 103.8
                    },
                    marker: {
                        position: false
                    },
                    class: "map-container",
                },
                containers: {
                    open: {
                        invites: true,
                        details: false,
                        updates: false,
                        itinerary: false
                    }
                }
            }
        },

        computed: {
            split_address() {
                return this.event.address_address.split(",");
            },

            address_first_line() {
                return this.split_address[0];
            },

            csv_filename() {
                return this.event.name + " Invite List.csv";
            },

            csv_invites(){
              return this.invites.map(invite=>{
                  invite.answers.forEach(answer=>{
                      // TODO: deleting a question doesn't delete its answer, 
                      // so when we try to load questions for answers, we can get an
                      // error here - answer.question is null, so trying to get
                      // .text causes an error
                      //
                      // adding this now as a bugfix for time reasons; need to
                      // detect question deletion and delete associated answers
                      if (answer.question !== null) {
                        invite[answer.question.text] = answer.text;
                      }
                  });
                  return invite;
              })
            },

            invites_accepted() {
                return this.invites.filter(invite => invite.status == "ACCEPTED").length;
            },

            invites_rejected() {
                return this.invites.filter(invite => invite.status == "REJECTED").length;
            },

            invites_seen() {
                return this.invites.filter(invite => invite.status == "VIEWED").length;
            },

            invites_sent() {
                return this.invites.filter(invite => invite.status == "SENT").length;
            },

            invites_unsent() {
                return this.invites.filter(invite => invite.status == "UNSENT").length;
            },

            has_itinerary_items() {
                return this.event && this.event.days.length > 0;
            }
        },

        methods: {
            closeContainers() {
                this.containers.open.invites = false;
                this.containers.open.details = false;
                this.containers.open.itinerary = false;
                this.containers.open.updates = false;
            },

            askDeleteInvite(item) {
                this.show_delete_modal = true;
                this.invite_to_delete = item;
            },
            
            deleteInvite() {
                inviteRepository.destroy(this.invite_to_delete.id)
                    .then(response => {
                        let id = this.invites.findIndex(invite => invite.id == this.invite_to_delete.id);

                        this.invites.splice(id, 1);
                        
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Invite deleted',
                            text: 'Invite successfully deleted.'
                        });
                    });
            },

            sendPendingInvites() {

                inviteRepository.sendEmails(this.invites.filter(i=>i.status=="UNSENT").map(i=>i.id))
                    .then(response =>{
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Invites Sent',
                            text: 'All unsent invites successfully sent.',
                        });

                        this._updateInvitesList(response.data);
                    }).catch(error=>{
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'Invites Not Sent',
                            text: 'Invites have failed to send.'
                        });
                    });

                inviteRepository.sendSMSMessages(this.invites.filter(i=>i.status=="UNSENT").map(i=>i.id))
                    .then(response =>{
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Invites Sent',
                            text: 'SMS messages successfully sent.',
                        });

                        // this._updateInvitesList(response.data);
                    }).catch(error=>{
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'Invites Not Sent',
                            text: 'SMS messages have failed to send.'
                        });
                    });

            },
            resendUnconfirmedInvites(){
                inviteRepository.sendEmails(this.invites.filter(i=>i.status=="UNSENT" || i.status=="SENT" || i.status=="VIEWED").map(i=>i.id))
                    .then(response =>{
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Invites Sent',
                            text: 'All unconfirmed invites have been successfully (re)sent.',
                        });

                        this._updateInvitesList(response.data);

                    }).catch(error=>{
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'Invites Not Sent',
                            text: 'Invites have failed to send.'
                        });
                    });

                inviteRepository.sendSMSMessages(this.invites.filter(i=>i.status=="UNSENT" || i.status=="SENT" || i.status=="VIEWED").map(i=>i.id))
                    .then(response =>{
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Invites Sent',
                            text: 'SMS messages successfully (re)sent.',
                        });

                        // this._updateInvitesList(response.data);
                    }).catch(error=>{
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'Invites Not Sent',
                            text: 'SMS messages have failed to send.'
                        });
                    });
            },

            _updateInvitesList(newInvites){
                console.log(newInvites);
                //this is probably slow, and could be improved by keeping a map of ids => array index, or using an object instead: data{invites:{1:{},2:{}},...}
                newInvites.forEach(i=>{
                    let id = this.invites.findIndex(invite => invite.id == i.id);
                    this.$set(this.invites[id], 'status', i.status);
                });
            }
        },
        
        mounted() {
            eventRepository.getById(this.id, {
                include: ['client', 'invites', 'questions', 'invites.answers.question', 'days', 'updates', 'days.itinerary_items']
            }).then(response => {
                this.event = response.data;
                this.invites = response.data.invites.map(invite =>{
                    invite.custom_fields.forEach(custom_field=>{
                        invite[custom_field.name] = custom_field.value;
                    });
                    return invite;
                });
                this.updates = response.data.updates;
                this.days = response.data.days;
                this.map.reported_center = {
                    lat: parseFloat(this.event.address_lat),
                    lng: parseFloat(this.event.address_lng)
                }
                this.map.marker.position = {
                    lat: parseFloat(this.event.address_lat),
                    lng: parseFloat(this.event.address_lng)
                }

                //merge custom invite fields
                response.data.client.custom_invite_fields.forEach(field => {
                    this.fields.unshift({
                        key:field.name,
                        sortable:true,
                    });
                    this.csv_fields.unshift(field.name);
                });

                //merge questions into csv fields (not shown in html table)
                response.data.questions.forEach(question=>{
                    this.csv_fields.push(question.text);
                });
                this.loaded = true;
            });
        }
        
    }
</script>

<style scoped lang="scss">
    .tb-form-field--with-append {

    }

    .tb-form-field__append {
        button {
            background-color: transparent;
            border: none;
            text-align: center;
        }
    }
</style>